import { render, staticRenderFns } from "./AdminAddNewCustomer.vue?vue&type=template&id=50b61ac7&scoped=true&"
import script from "./AdminAddNewCustomer.vue?vue&type=script&lang=ts&"
export * from "./AdminAddNewCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./AdminAddNewCustomer.vue?vue&type=style&index=0&id=50b61ac7&lang=scss&scoped=true&"
import style1 from "./AdminAddNewCustomer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b61ac7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VChip,VCol,VDataTable,VForm,VIcon,VRow,VSelect,VTextField})
